export default __webpack_public_path__ + "static/media/home_logo.733f400a.png";